 <template>
 <div  class="main"> 
   <div class="x-subnav">
     <xy-toolbox-menu class="l" :items="saleMenu" current="装备销量"  />
     <div class="r action-btn-box" v-show="!viewResult">
        <el-button @click="onShowSelectDatetime" type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >
        进入分析 
           <svg-icon name="play" size="12" ></svg-icon>
           
           </el-button>
      </div>
     <xy-toolbox-menu class="r" v-show="viewResult">
       <xy-toolbox-menu-item icon="car_search" @click="chooseCars" >返回</xy-toolbox-menu-item>
       <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出  </xy-toolbox-menu-item>
     </xy-toolbox-menu>
   </div>
<SearchBar :moduleName="currentModuleName" v-if="!viewResult"> 
 
 <el-collapse v-model="recentScheme" slot="defaultContent">
                 <el-collapse-item title="近期筛选方案" name="1"  >
                 <div class="recent-search-wrapper">
                  <el-row :gutter="12">
                    <el-col :span="6" v-for="(schemea,index) in savedSearchSchemas" :key="index"><SearchPlan :schemea="schemea"  @watchChild="showAdvancedSearchPanel" /></el-col>     
                  </el-row>
                 </div>
                </el-collapse-item>
           <el-collapse-item title="近期研究方案" name="2" >
            <div class="recent-research-wrapper">             
                <el-row :gutter="12">
                 
                </el-row>
            </div>
              </el-collapse-item>
            </el-collapse>
</SearchBar>

<div   v-if="viewResult" style="margin-top:20px;">
<el-row :gutter="0">
  <el-col :span="18" ><el-button type="primary" @click="goto">添加车款 </el-button>   <el-button type="primary">Excel导出</el-button>    </el-col>
  <el-col :span="6"></el-col>
</el-row>


</div>

 <el-dialog width="1100px"  
            :visible.sync="showSelectDatetime"
            :center="false"
            :append-to-body="true" title="装备分析选项">
            <el-row :gutter="20">
           <el-col :span="14">         
              <span slot="dialog-title">选择分析时间</span>
               <el-date-picker  type="monthrange" v-model="daterange" :picker-options="pickerOptions" value-format="yyyy-MM"></el-date-picker> 
            </el-col>
            <el-col :span="10">     
           <el-select v-model="dataSource" placeholder="请选择数据来源"  >
             <el-option   v-for="item in saleCategories" :key="item.id" :label="item.name" :value="item.name" > </el-option>
           </el-select>
           </el-col>

 <el-col :span="24">
 <div style="border-top: 1px solid #eaeefb; margin:15px 0;"></div>

 </el-col>
      <el-col :span="12">
           <div class="leftbox">
            <div>
              <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select" clearable prefix-icon="el-icon-search">
              <el-select v-model="equipType" slot="prepend" placeholder="全部装备" style="width: 130px;">
              <el-option label="全部装备" value="全部"> </el-option>
    <el-option
      v-for="item in this.equipCategories"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
  </el-input>
  </div>
  <div>
      <el-table :data="SelectionTags" style="width: 100%"  height="450">
      <el-table-column prop="name" label="装备名称" width="180"> </el-table-column>
      <el-table-column prop="val" label="装备选项" min-width="180"> </el-table-column>
        <el-table-column label="操作"  width="120" >
          <template slot-scope="scope">
            <el-button @click="handleContain(scope.$index, scope.row)" icon="el-icon-plus" circle  :type="scope.row.status==2?'primary':''">  </el-button>
          </template>
        </el-table-column>
  </el-table>
  </div>
  </div>
</el-col>

<el-col :span="12">
                <p class="ttip"><strong>查询</strong> 以下装备 ...</p>
                <div class="containbox">
                      <el-tag :key="tag.id" v-for="tag in includeTags" closable :disable-transitions="false" @close="handleClose(tag)">{{tag.name +':'+ tag.val}}</el-tag>
                </div>
          </el-col>
</el-row>


       <span slot="footer">
                <el-button @click="onHideSelectDatetime">返回</el-button>
                <el-button @click="gotoAnalyze" type="primary">生成透视表</el-button>
            </span>
        </el-dialog>
 
</div>
</template>
<script>
import { mapMutations, mapGetters ,mapActions} from 'vuex';
import SearchBar from '@/components/common/NewSearchBar.vue';
import SearchPlan from '@/components/search/SearchPlan.vue';
import ResearchPlan from '@/components/search/ResearchPlan.vue';
import GUID from  '../../store/guid';
export default {
    name: 'EquipSaleAnalysis',
       components: {SearchBar},
    data(){
        return {
            recentScheme:['1','2'],
            viewResult:false,
            showSelectDatetime:false,
            currentModuleName:'EquipSaleAnalysis',
             dataSource:'乘联会销量管理',
             daterange:null,
             equipType:'全部',
                  keyword:'',
  
          pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近二个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
     methods: {
         
           ...mapMutations('commonsearch', ['setPivotTableKey' ,'clearSearch' ]),
           ...mapActions('commonsearch', ['savePivotTableAsync' ,'getSaleCategories','saveLinesPivotTableAsync' ]),
              ...mapActions('searchequip', [
            'saveEquipSearchSchema',
            'queryEquipList',
            'doSearch',
            'loadEquipSearchSchema',
            'selectEquipSearchSchema'
        ]),
           onShowSelectDatetime(){
            this.showSelectDatetime = true;
        },
        onHideSelectDatetime()
        {
             this.showSelectDatetime = false;
        },
         goto(){
     
           this.viewResult = !this.viewResult;
         },

          handleContain(index, row){

          row.status = 2;
          console.log(index, row);
      },
      handleRemove(index, row){
              row.status = 4;
        console.log(index, row);

      },
       handleClose(tag) {
        tag.status = 1;
      },
         showAdvancedSearchPanel(){},      
       // 进入分析
        gotoAnalyze() {
                if(this.daterange == null)
                {
                     this.$message({
                    type: 'error',
                    message: '没有选择日期',
                    duration: 2000,
                });
                    return ;
                }
                var key = new GUID().newGUID();
                this.saveLinesPivotTableAsync({key:key ,cb:this.gotoPivotTable });

        },
        gotoPivotTable(key)
        {
            var self = this;
              this.$router.push({
                name: 'flexmonster',
                query: {
                    datatype: 'equip',
                    pivotTableKey:key,
                    daterange:this.daterange,
                    source: this.dataSource,
                    ids :self.includeTags.map(x=>x.id)
                }
            });
        }
     },
     computed:{
          ...mapGetters('commonsearch', {
               searchResult: "selectionResult",
            'saleCategories':'saleCategories',
            'savedSearchSchemas':'savedSearchSchemas'
            }),
         ...mapGetters('searchequip', [
            'savedEquipSearchSchemas',
            'searchParams',
            'equipOptions',
            'equipCategories','getSavedEquipSearchSchema'
        ]),

         includeTags(){
        return this.equipOptions.filter(item=>{return item.status == 2});
      },
         SelectionTags(){
      
         return this.equipOptions.filter(item=>{return     (this.keyword=='' || (item.val.indexOf(this.keyword)>-1) || item.name.indexOf(this.keyword)>-1 )  && (this.equipType=='全部' ||item.tag== this.equipType) });
      },
     },
    mounted() {
           this.clearSearch();
           this.getSaleCategories({cb:null});
           if(this.equipOptions==null || this.equipOptions.length ==0)
           {

                 this.queryEquipList();
           }

    },
    watch:{
      saleCategories(newVale)
      {
        
      }
    }
    
}
</script>
<style scoped>
.equip-main{  padding: 80px 60px; }
.grid-hover{   color: rgb(0, 162, 255); box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.2); }
.grid-content{ box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);  padding: 10px; min-height: 260px; cursor: pointer; }
.grid-content .icon{ margin-top:3em;}
.grid-content .icon i {font-size: 3em;}
.search-wrapper {  line-height: 24px;}
.label{  line-height: 40px;}
.leftbox, .containbox,.removebox{  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); padding:8px;}
.ttip{ padding-left:20px;}
.el-tag + .el-tag {margin-left: 10px; margin-top:10px;}
.containbox,.removebox{ margin-left: 20px; min-height: 442px;}
.el-table::before{ height:0;}
</style>